import { createContext } from 'react';
import { SettingsLayoutSection } from './settingsLayout';

export type SettingsLayoutContextGetSectionContent = (
	id: string,
	panelName: () => string,
	isNarrow?: boolean,
) => JSX.Element;

export const SettingsLayoutContext = createContext<{
	sections: SettingsLayoutSection[];
	activeId: string;
	activeTabData: SettingsLayoutSection;
	handleChangeSection: (section: SettingsLayoutSection) => void;
	getSectionContent: SettingsLayoutContextGetSectionContent;
}>({
	sections: [],
	activeId: '',
	activeTabData: null,
	handleChangeSection: null,
	getSectionContent: null,
});
